<template>
  <v-container fluid>
    <material-card icon="mdi-clipboard-text" inline title="My Audit Reports">
      <v-card-actions>
        <a @click="$router.back()">
          <v-btn v-if="$vuetify.breakpoint.smAndUp" elevation="1" absolute right top>
            <v-icon left>mdi-arrow-left</v-icon>back
          </v-btn>
          <v-btn v-else fixed right fab small color="grey lighten-2" elevation="1"
            class="mr-n2 mt-10" style="opacity:.6;">
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
        </a>
      </v-card-actions>
      <v-card-component>
        <!--Filter header start -->
        <v-row>
          <v-col class="mt-4" cols="12" sm="3">
            <v-menu ref="menu" v-model="menu" :close-on-content-click="false"
              :return-value.sync="date" transition="scale-transition" offset-y max-width="290px"
              min-width="auto">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field v-model="date" label="Month" prepend-icon="mdi-calendar" readonly
                  v-bind="attrs" v-on="on"></v-text-field>
              </template>
              <v-date-picker v-model="date" type="month" no-title scrollable>
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="menu = false">
                  Cancel
                </v-btn>
                <v-btn text color="primary" @click="$refs.menu.save(date);getTeacherAudits()">
                  OK
                </v-btn>
              </v-date-picker>
            </v-menu>
          </v-col>
          <!-- <v-col cols="12" md="3">
            <label>Score Range</label>
            <v-range-slider v-model="range" :max="max" :min="min" hide-details class="align-center">
              <template v-slot:prepend>
                <v-text-field label="Start Range" :value="range[0]" class="mt-0 pt-0" hide-details
                  single-line type="number" min="0" max="100" style="width: 60px"
                  @change="$set(range, 0, $event);"></v-text-field>
              </template>
              <template v-slot:append>
                <v-text-field label="End Range" :value="range[1]" class="mt-0 pt-0" hide-details
                  single-line type="number" min="0" max="100" style="width: 60px"
                  @change="$set(range, 1, $event);"></v-text-field>
              </template>
            </v-range-slider>
          </v-col> -->

          <v-col class="mt-2" sm="3">
            <label class="font-weight-medium body-2">
              Type
            </label>
            <v-autocomplete class="my-0 py-1" placeholder="--Select class--" name="sectionSelect"
              v-model="selectedtype" required v-on:change="getTeacherAudits()" item-value="id"
              :items="typeOptions">
            </v-autocomplete>
          </v-col>
          <!-- <v-col class="mt-2" sm="3">
            <v-btn class="mt-4" elevation="1" color="success" @click="getTeacherAudits()">
              <v-icon left>mdi-magnify</v-icon>Search
            </v-btn>
          </v-col> -->
        </v-row>
        <!--Filter header end -->

        <!--Data table start -->
        <v-data-table :headers="headers" :items="tableData" disable-pagination hide-default-footer>
          <template v-slot:item.id="{ item }">
            <v-btn color="success" class="px-2 ml-1 ma-1" min-width="0" small
              v-on:click="()=>{$router.push({ name: 'viewMyAudit', params: {id: item.id} })}">
              <v-icon small> mdi-notebook-edit-outline </v-icon>
              <span class="ms-2">
                {{ item.role==='ACADEMIC_ADMIN' ? 'Acad Manager Report' : 'CH Report' }}
              </span>
            </v-btn>
          </template>
          <!-- <template v-slot:item.isActive="{ item }">
            {{ item.isActive ? 'YES' : 'NO' }}
          </template>
          <template v-slot:item.serviceFranchiseeMaps="{ item }">
            <p v-for="values in item.serviceFranchiseeMaps" :key="values.id">{{ values.franchisee.companyName }}</p>
          </template>

          <template v-slot:item.actions="{ item }">
            <v-btn v-if="item.isActive" color="success" class="px-2 ml-1 ma-1" @click="getSingle(item)" min-width="0" small>
              <v-icon small> mdi-pencil </v-icon>
            </v-btn>

            <v-btn color="error" v-if="item.isActive" class="px-2 ml-1 ma-1" @click="statusUpdate(item.id)" min-width="0" small>
              <v-icon small> mdi-trash-can-outline </v-icon>
            </v-btn>
            <v-btn color="success" v-else class="px-2 ml-1 ma-1" @click="statusUpdate(item.id)" min-width="0" small>
              <v-icon small> mdi-reload </v-icon>
            </v-btn>
          </template> -->

          <template v-slot:no-data>
            <v-card-subtitle class="d-flex justify-center">No Data Available</v-card-subtitle>
          </template>
        </v-data-table>
        <!--Data table end -->
        <!--Pagination start-->
        <v-row>
          <v-col cols="4" sm="3">
            <v-select v-model="pageSize" :items="pageSizes" label="Items per Page"
              @change="handlePageSizeChange"></v-select>
          </v-col>
          <v-col cols="12" sm="9">
            <v-pagination v-model="page" :length="totalPages" :total-visible="totalPages"
              @input="handlePageChange">
            </v-pagination>
          </v-col>
        </v-row>
        <!--Pagination end-->
      </v-card-component>
    </material-card>

    <!-- <loading-icon :value="isLoading" />
     <v-btn v-on:click="()=>{$router.push({ name: 'addAudit', params: {type: 'online'}})}"
              v-if="isWrite" elevation="1" :class="{ 'mt-2': $vuetify.breakpoint.xs }"
              color="accent">
              <v-icon left>mdi-plus</v-icon>
              Online Audit
            </v-btn>
            <v-btn class="ml-2"
              v-on:click="()=>{$router.push({ name: 'addAudit', params: {type: 'offline'} })}"
              v-if="isWrite" elevation="1" :class="{ 'mt-2': $vuetify.breakpoint.xs }"
              color="accent">
              <v-icon left>mdi-plus</v-icon>
              Offline Audit
            </v-btn>
             -->
  </v-container>
</template>

<script>
import MaterialCard from '@/components/template/MaterialCard'
import VCardComponent from '@/components/template/VCardComponent'
import constants from '@/utils/constants'
import moment from 'moment'
import { mapGetters } from 'vuex'

export default {
  components: { VCardComponent, MaterialCard },
  computed: {
    ...mapGetters({
      franchisee: 'getFranchisee',
      academicYear: 'getAcademicYear'
    })
  },
  watch: {
    franchisee: async function () {
      this.getTeacherAudits()
    }
  },
  async created () {
    this.getTeacherAudits()
  },
  data () {
    return {
      isWrite: true,
      search: '',
      tableData: [],
      min: 0,
      max: 100,
      range: [0, 100],
      headers: [
        { text: 'Month', value: 'months', sortable: true },
        { text: 'Score', value: 'overallScore', sortable: true },
        { text: 'Date', value: 'auditDate', sortable: true },
        { text: 'Class', value: 'className[0].name', sortable: true },
        { text: 'Status', value: 'type', sortable: true },
        { text: 'Report', value: 'id', sortable: true }
      ],
      typeOptions: ['All', 'online', 'offline'],
      selectedtype: 'All',
      date: new Date().toISOString().substr(0, 7),
      menu: false,
      modal: false,
      scoreOptions: [],
      score: '',
      page: 1,
      pageSize: 10,
      pageSizes: [5, 10, 20],
      totalPages: 0
    }
  },
  methods: {
    async getTeacherAudits () {
      const { data } = await http.get(`${constants.API_URL}/api/center-audit/audit/teacherauditlist`, {
        params: {
          page: this.page - 1,
          size: this.pageSize,
          search: this.search,
          // startRange: this.range[0],
          // endRange: this.range[1],
          type: this.selectedtype === 'All' ? '' : this.selectedtype,
          month: parseInt(moment(this.date).month()) + 1,
          franchiseeID: this.franchisee.id
        }
      })
      this.totalPages = data.totalPages
      this.tableData = data.rows.map((item) => {
        item.months = moment.months(parseInt(item.months) - 1)
        item.auditDate = moment(item.auditDate).format('LL')
        return item
      })
      console.log(data)
    },
    handlePageChange: function () {
      console.log(`Page: ${this.page}`)
      this.getTeacherAudits()
    },
    handlePageSizeChange: function () {
      console.log(`Page Size: ${this.pageSize}`)
      this.getTeacherAudits()
    }
  }
}
</script>

<style>
</style>
